import { render, staticRenderFns } from "./g-upload-plain.vue?vue&type=template&id=b42e0192&"
import script from "./g-upload-plain.vue?vue&type=script&lang=js&"
export * from "./g-upload-plain.vue?vue&type=script&lang=js&"
import style0 from "./g-upload-plain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports